import { render, staticRenderFns } from "./S3FileComponent.vue?vue&type=template&id=26c459b9"
import script from "./S3FileComponent.vue?vue&type=script&lang=js"
export * from "./S3FileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports